import checkout from "./form";

const {
  formField: {
    bankName,
    taxId,
    address,
    city,
    district,
    ward,
    sentDate,
    sendingPeriod,
    sendingTimes,
    bankId,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [bankName.name]: "",
  [taxId.name]: "",
  [address.name]: "",
  [city.name]: "",

  [district.name]: "",
  [ward.name]: "",
  [sentDate.name]: "",
  [sendingPeriod.name]: "",
  [sendingTimes.name]: "",
  [bankId.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
